import React from 'react';
import Chart from './Chart';
import { Helmet } from 'react-helmet-async';

function Home() {
  return (
    <>
      <Helmet>
        <title>Covid-19 čakáreň dáta</title>
        <meta name="description" content="Štatistiky z Covid-19 čakárne" />
        <link rel="canonical" href="https://cakaren.vercel.app" />
        <meta property="og:url" content="https://cakaren.vercel.app" />
        <meta
          property="og:image"
          content="https://cakaren.vercel.app/preview.png"
        />
        <meta property="og:title" content="Covid-19 čakáreň dáta" />
        <meta
          property="og:description"
          content="Štatistiky z Covid-19 čakárne"
        />
      </Helmet>
      <Chart />
    </>
  );
}

export default Home;
